module.exports = __webpack_public_path__ + "html/toast-item.template.html";